export default "__VITE_ASSET__3RKWTuUQ__";